import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { destroyAsset } from "../../../../actions/roblox/assetsActions";
import { useNavigate } from "react-router-dom";
import { selectAssetEntities, selectAssetIds, setEditId } from "../../../../store/roblox/assetsSlice";

import { message, Spin } from "antd";
import CardImage from "../../../../componets/CardImage";
import Pagination from '../../../../componets/Pagination';
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import { formattedDate } from "../../../../helpers/DateHelpers";
import Edit from "../Edit";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const ids       = useAppSelector(selectAssetIds);
  const assets    = useAppSelector(selectAssetEntities);
  const count     = useAppSelector(state => state.roblox.assets.count);
  const error     = useAppSelector(state => state.roblox.assets.error);
  const status    = useAppSelector(state => state.roblox.assets.status);

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAsset(id));

    if (destroyAsset.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyAsset.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderAsset = (id: EntityId) => {
    const asset = assets[id];

    if (!asset) {
      return;
    }
    const formattedCreatedAt = formattedDate(asset.created_at);

    return (
      <CardImage
        key={asset.id}
        title={asset.title}
        image={asset.item_url}
        size='medium'
        options={[
          <ButtonEdit key={`edit-${asset.id}`} onClick={() => onClickEdit(asset.id)} />,
          <ButtonDestroy key={`destroy-${asset.id}`} onClick={() => onClickDestroy(asset.id)} />
        ]}>

        <div className='v-small_text'>
          {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
        </div>
      </CardImage>
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {ids && ids.map(renderAsset)}

      {<Pagination total={count} size={limit} />}

      <Edit />
    </>
  );
}

export default _List;
